module.exports = __webpack_public_path__ + "assets/300b5e03c9b3a15f1181ee06553cc287.mp3";